import React from "react";
import {ReactComponent as icon} from "./IconClose.svg";

export const IconClose = () => React.createElement(icon);
